<template>
  <div class="move-button" :class="classes" @click="clickHandler">
    <slot></slot>
    <i-spin v-if="loading" fix>
      <i-icon type="ios-loading" size="18" class="spin-icon-load" />
    </i-spin>
  </div>
</template>

<script>
export default {
  name: 'MoveButton',
  props: {
    size: {
      type: String,
      default: 'default',
    },
    type: {
      type: String,
      default: 'default',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return `move-btn-${this.size} move-type-${this.type}`;
    },
  },
  methods: {
    clickHandler(event) {
      if (this.loading) return;
      this.$emit('click', event);
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/fonts/font.less';
@import '../../assets/css/main.less';
.move-button {
  .font-light;
  position: relative;
  &.move-type-default {
    background: @app-color;
    color: #ffffff;
  }
  &.move-type-outline {
    border: 1px solid @app-color;
    color: @app-color;
  }
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 300;
  padding: 0 15px;
  &.move-btn-default {
    height: 46px;
  }
  &.move-btn-large {
    height: 36px;
  }
}
</style>
